<template>
  <hm-content title="">
    <div class="mb10  flex flex-between">
      <el-button type="primary" size="small" @click="add">新增规则</el-button>
      <div>
        <el-select
          size="small"
          clearable
          placeholder="请选择金豆状态"
          v-model="searchCondition.useStatus"
          class="mr10"
          filterable
        >
          <el-option label="开启" value="yes"></el-option>
          <el-option label="作废" value="no"></el-option>
        </el-select>
        <el-input
          style="width:280px"
          clearable
          v-model.trim="searchCondition.name"
          placeholder="请输入金豆别称"
          size="small"
          class="ipt mr10"
        >
        </el-input>
        <el-button type="primary" size="small" @click="search">查询</el-button>
      </div>
    </div>
    <div class="table">
      <el-table
        :data="list"
        style="width: 100%"
        stripe
        size="small"
        border
        ref="table"
      >
        <el-table-column
          header-align="center"
          align="center"
          type="index"
          label="序号"
          width="50"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="金豆别称"
          prop="name"
        ></el-table-column>
        <el-table-column header-align="center" align="center" label="有效期">
          <template slot-scope="scope">
            {{ scope.row.startTime }} - {{ scope.row.endTime }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="useStatus"
          label="金豆状态"
        >
          <template slot-scope="scope">
            <div :class="scope.row.useStatus === 'yes' ? 'success' : 'danger'">
              {{ scope.row.useStatus === "yes" ? "开启" : "作废" }}
            </div>
          </template>
        </el-table-column>

        <el-table-column
          label="操作"
          header-align="center"
          align="center"
          width="200"
        >
          <template slot-scope="scope">
            <div class="flex flex-center item-center">
              <el-button
                type="text"
                size="small"
                :disabled="scope.row.useStatus === 'no'"
                @click="remove(scope.row)"
              >
                作废
              </el-button>
              <el-divider direction="vertical"></el-divider>
              <el-button
                type="text"
                size="small"
                :class="scope.row.useStatus === 'no' ? 'gray' : 'blue'"
                :disabled="scope.row.useStatus === 'no'"
                @click="detail(scope.row, 'edit', '编辑规则')"
              >
                编辑
              </el-button>
              <el-divider direction="vertical"></el-divider>
              <el-button
                type="text"
                size="small"
                class="blue"
                @click="detail(scope.row, 'detail', '查看规则')"
              >
                查看
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="hm-pagination">
      <el-pagination
        background
        :total="total"
        @current-change="paging"
        @size-change="handleSizeChange"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="currentPage"
      ></el-pagination>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      :title="title"
      :visible.sync="dialogVisible"
      width="1000px"
    >
      <el-form
        ref="ruleForm"
        :model="ruleForm"
        :rules="rules"
        label-width="150px"
      >
        <el-form-item label="金豆别称" prop="name">
          <el-input
            v-model.trim="ruleForm.name"
            size="small"
            clearable
            style="width:350px"
            :disabled="type === 'detail'"
            placeholder="请输入金豆名，不超过5个字（手机端金豆名称显示）"
          ></el-input>
        </el-form-item>
        <el-form-item label="金豆使用订单门槛" prop="levelMin">
          <el-input
            v-model.trim="ruleForm.levelMin"
            maxlength="20"
            size="small"
            clearable
            placeholder="请输入金额"
            :disabled="type === 'detail'"
            @input="filterGt0OrFixed2('levelMin')"
          ></el-input>
          <div class="form-item-tip">
            订单金额达到多少才允许使用金豆支付
          </div>
        </el-form-item>
        <el-form-item label="金豆使用比例" prop="exchangeRatio">
          使用
          <el-input
            :disabled="type === 'detail'"
            v-model.trim="ruleForm.exchangeRatio"
            maxlength="20"
            clearable
            size="small"
            placeholder="请输入金豆数量"
            @input="filterGt0OrFixed0('exchangeRatio')"
          ></el-input
          >金豆=
          <el-input
              :disabled="type === 'detail'"
              v-model.trim="ruleForm.exchangeMoney"
              maxlength="20"
              clearable
              size="small"
              placeholder="请输入金额"
              @input="filterGt0OrFixed2('exchangeMoney')"
          ></el-input>元
        </el-form-item>
        <el-form-item label="金豆使用满足倍数" prop="useTimes">
          使用
          <el-input
            :disabled="type === 'detail'"
            v-model.trim="ruleForm.useTimes"
            maxlength="20"
            clearable
            size="small"
            placeholder="请输入整数"
            @input="filterGt0OrFixed0('useTimes')"
          ></el-input
          >倍
          <div class="form-item-tip">
            金豆达到指定倍数才能使用，例如10倍，则金豆数只能10倍抵扣，例如10金豆、20金豆.以此类推
          </div>
        </el-form-item>
        <el-form-item label="单笔订单最大可使用" prop="useMaxNum">
          <el-input
              :disabled="type === 'detail'"
              v-model.trim="ruleForm.useMaxNum"
              maxlength="20"
              clearable
              size="small"
              placeholder="请输入整数"
              @input="integerMultiple('useMaxNum')"
          ></el-input>
        </el-form-item>
        <el-form-item label="使用金豆时间" prop="applyDate">
          <el-date-picker
            :disabled="type === 'detail'"
            v-model="ruleForm.applyDate"
            type="datetimerange"
            align="right"
            ref="applyDatePicker"
            :default-time="['00:00:00', '23:59:59']"
            start-placeholder="使用开始时间"
            end-placeholder="使用结束时间"
            value-format="yyyy-MM-dd HH:mm:ss"
            size="small"
            class="mr10"
          ></el-date-picker>
        </el-form-item>
      </el-form>

      <div class="btn-wrapper flex flex-center" slot="footer">
        <el-button
          size="small"
          type="primary"
          @click="save"
          v-if="type !== 'detail'"
          >确 定</el-button
        >
        <el-button size="small" @click="dialogVisible = false">取 消</el-button>
      </div>
    </el-dialog>
  </hm-content>
</template>

<script>
export default {
  data() {
    return {
      title: "",
      dialogVisible: false,
      ruleForm: {
        name: "",
        levelMin: "",
        exchangeRatio: "",
        useTimes: "",
        applyDate: "",
        useMaxNum: "",
        exchangeMoney: "",
      },
      rules: {
        name: [
          {
            required: true,
            trrger: "change",
            message: "请输入金豆别称"
          },
          { max: 5, message: "长度在5个字符内", trigger: "change" }
        ],
        levelMin: {
          required: true,
          trigger: "change",
          message: "请输入金额"
        },
        exchangeRatio: {
          required: true,
          trigger: "blur",
          message: "请输入金豆数量"
        },
        useTimes: {
          required: true,
          trigger: "blur",
          message: "请输入整数"
        },
        applyDate: {
          required: true,
          trigger: "blur",
          message: "请输入时间段"
        }
      },
      list: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      searchCondition: {},
      type: ""
    };
  },
  created() {},
  mounted() {
    this.queryList();
  },
  methods: {
    filterGt0OrFixed2(prop) {
      this.ruleForm[prop] = this.ruleForm[prop].replace(/[^\d.]/g, ""); //仅保留数字和"."
      this.ruleForm[prop] = this.ruleForm[prop].replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
      this.ruleForm[prop] = this.ruleForm[prop]
        .replace(".", "$#*")
        .replace(/\./g, "")
        .replace("$#*", "."); //去除其他"."
      this.ruleForm[prop] = this.ruleForm[prop].replace(
        /^(\d+)\.(\d\d).*$/,
        "$1.$2"
      ); //限制只能输入两个小数
      if (this.ruleForm[prop].indexOf(".") < 0 && this.ruleForm[prop] != "") {
        //首位是0的话去掉
        this.ruleForm[prop] = parseFloat(this.ruleForm[prop]);
      }
    },
    filterGtrFixed2(prop) {
      // this[prop] = this[prop].replace(/^(0+)/, ""); //过滤0开头
      this[prop] = this[prop].replace(/[^\d.]/g, ""); //仅保留数字和"."
      this[prop] = this[prop].replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
      this[prop] = this[prop]
          .replace(".", "$#*")
          .replace(/\./g, "")
          .replace("$#*", "."); //去除其他"."
      this[prop] = this[prop].replace(/^(\d+)\.(\d\d).*$/, "$1.$2"); //限制只能输入两个小数
      if (this[prop].indexOf(".") < 0 && this[prop] != "") {
        //首位是0的话去掉
        this[prop] = parseFloat(this[prop]);
      }
    },
    filterGt0OrFixed0(prop) {
      this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)/, ""); //过滤0开头
      this.ruleForm[prop] = this.ruleForm[prop].replace(/[^\d]/g, "");
      this.ruleForm[prop] = this.ruleForm[prop]
        .replace(".", "")
        .replace("-", "")
        .replace(",", "");

      this.ruleForm[prop] = new Number(this.ruleForm[prop]);
    },
    integerMultiple(prop) {
      if (this.ruleForm.useTimes) {
        if (this.ruleForm.useMaxNum / this.ruleForm.useTimes %1 != 0) {
          return false;
        }
      }
      return true;
    },
    resetRuleForm() {
      setTimeout(() => {
        this.$refs.ruleForm.resetFields();
        this.ruleForm.ruleId = "";
        this.ruleForm.applyDate = "";
        this.ruleForm.exchangeMoney = "";
      }, 0);
    },
    add() {
      this.type = "add";
      this.title = "新增规则";
      this.dialogVisible = true;
      this.resetRuleForm();
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    async save() {
      const valid = await this.$refs.ruleForm.validate();

      if (valid) {
        if (!this.integerMultiple()) {
          this.$message({
            type: "warning",
            message: "单笔订单最大可使用必须是金豆使用的倍数"
          });
        } else {
          let params = JSON.parse(JSON.stringify(this.ruleForm));
          params.startTime = this.ruleForm.applyDate[0];
          params.endTime = this.ruleForm.applyDate[1];

          let url =
              this.type === "add"
                  ? "addStoreGoldBeanRule"
                  : "editStoreGoldBeanRule";
          await this.$store.dispatch(url, params);
          this.$message({
            type: "success",
            message: "操作成功"
          });
          this.queryList();
          this.dialogVisible = false;
        }
      } else {
        return;
      }
    },
    async remove(row) {
      const result = await this.$confirm("作废本行规则?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).catch(() => {});
      if (result === "confirm") {
        let params = JSON.parse(JSON.stringify(row));
        params.useStatus = "no";
        await this.$store.dispatch("editStoreGoldBeanRule", params);
        this.$message({
          type: "success",
          message: "操作成功"
        });
        this.queryList();
      }
    },
    detail(row, type, title) {
      this.title = title;
      this.$nextTick(() => {
        for (let key in row) {
          if (this.ruleForm.hasOwnProperty(key)) {
            this.ruleForm[key] = row[key];
          }
        }
      });

      this.ruleForm.applyDate = [row.startTime, row.endTime];
      this.ruleForm.ruleId = row.ruleId;
      this.row = row;
      this.type = type;
      this.dialogVisible = true;
    },
    async queryList() {
      const params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      Object.assign(params, searchCondition);
      const { code, result } = await this.$store.dispatch(
        "storeGoldBeanRulePage",
        params
      );
      if (code === "0") {
        const { total, records } = result;
        this.list = records;
        this.total = total;
      }
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    }
  }
};
</script>

<style scoped lang="scss"></style>
